<ig-accordion #customPlaceAccordion id="place-filter-custom" title="FAVORITE PLACES"
    class="top-bar-font-size editor-btn" [maxHeight]="400" (onClearFilter)="all()">
    <div item (click)="all()">
        All Places
    </div>
    <div item *ngIf="!isHideEditorChoice" [class.selected]="command.queryCommand.choice" (click)="editChoice()">
        {{editorChoiceText}}
        <mat-icon>favorite</mat-icon>
    </div>
    <div item *ngFor="let place of customPlaces"
        [class.selected]="selectedCustomPlace&&selectedCustomPlace._id===place._id" (click)="getFeedPlace(place)">
        <span>{{place.btnText}}</span>
    </div>
</ig-accordion>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/custom.place.btn/custom.place.btn.component.html